import { render, staticRenderFns } from "./MfaVerification.vue?vue&type=template&id=2d38c220&scoped=true&"
import script from "./MfaVerification.vue?vue&type=script&lang=js&"
export * from "./MfaVerification.vue?vue&type=script&lang=js&"
import style0 from "./MfaVerification.vue?vue&type=style&index=0&id=2d38c220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38c220",
  null
  
)

export default component.exports